export enum WheelOfferType {
  WALLET_POINT = 'WALLET_POINT',
  OTHER = 'OTHER',
  EXTERNAL = 'EXTERNAL',
  UNIQUE_CODE = 'UNIQUE_CODE'
}
